import React from 'react';

import { Icon } from '@eika/icon';

import InstructionStepType, { InstructionStepNoIconType } from './types';

const InstructionStep = (instructionStep: InstructionStepType | InstructionStepNoIconType) => {
    if ('icon' in instructionStep) {
        return (
            <li className="instruction-step">
                <div className="step-icon-container">
                    <Icon type={instructionStep.icon} />
                    <span className="dotted-separator" />
                </div>
                <small className="instruction-step-text">{instructionStep.text}</small>
            </li>
        );
    }

    return (
        <li className="instruction-step">
            <small className="instruction-step-text">{instructionStep.text}</small>
        </li>
    );
};

export default InstructionStep;
